import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DownloadModel, EasyDgdService } from '@hazmatsuite-next/easydgd-lib';
import { LanguageService, PaymentType } from '@hazmatsuite-next/ui';
import { Observable, map, take } from 'rxjs';
import { selectStepState } from '../../store/easydgd-data.selectors';
import { EasyDgdDataState } from '../../store/easydgd-data.reducer';
import { Store } from '@ngrx/store';

@Component({
  selector: 'easydgd-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadComponent implements OnInit {
  public downloadUrl = '';
  public subscriptionsUrl = `/${this.languageService.getLanguage()}/account/subscriptions`;
  public paymentTypes = PaymentType;
  public showShareModal = false;

  public stepperItems$ = this.easyDgdStore.select(selectStepState);
  public downloadResource$: Observable<any> = this.languageService.translations$.pipe(
    map(translations => translations['DownloadResource']));
  public commonResource$: Observable<any> = this.languageService.translations$.pipe(
    map(translations => translations['CommonResource']));
  public paymentResource$: Observable<any> = this.languageService.translations$.pipe(
    map(translations => translations['PaymentResources']));
  public validationResource$: Observable<any> = this.languageService.translations$.pipe(
    map(translations => translations['ValidationResource']));

  public shareForm = new FormGroup({
    sender: new FormControl('', Validators.required),
    recipient: new FormControl('', [Validators.required, Validators.email]),
  });
  model?: DownloadModel;

  constructor(
    private activatedRoute: ActivatedRoute,
    private easyDgdStore: Store<{ easyDgdState: EasyDgdDataState }>,
    private easydgdService: EasyDgdService,
    private languageService: LanguageService) {
  }

  ngOnInit(): void {
    this.model = this.easydgdService.downloadModel;
    this.downloadUrl = `${this.languageService.getLanguage()}/EasyDgd/DownloadFile?filename=${this.model?.Filename}`;
  }

  selectStep(index: number): void {
    // this.easydgdService.activateStep(index, this.activatedRoute);
  }

  share(): void {
    if (this.shareForm.invalid) {
      return this.shareForm.markAllAsTouched();
    }

    this.easydgdService.share({
      Filename: this.model?.Filename as string,
      Name: this.sender?.value as string,
      RecipientEmailAddress: this.recipient?.value as string
    }).pipe(take(1)).subscribe(() => {
      this.showShareModal = false;
    });
  }

  restartModule(): void {
    this.easydgdService.reset().pipe(
      take(1)).subscribe(() => {
        // this.easydgdService.activateStep(0, this.activatedRoute);
      });
  }

  get sender() {
    return this.shareForm.get('sender');
  }
  get recipient() {
    return this.shareForm.get('recipient');
  }
}
